import { useRef } from 'react';
import MainAccBalance from '../component/account-balance/Acc-balance';
import BalanceRecords from '../component/account-balance/Balance-records';
import { Row, Col } from 'antd';

export default function BalanceRecord() {
  const balanceRecordsRef = useRef<{ fetchBalanceRecord: () => void } | null>(
    null
  );
  const mainAccBalanceRef = useRef<{ fetchBalance: () => void } | null>(null);

  const handleAddMoneySuccess = () => {
    mainAccBalanceRef.current?.fetchBalance();
    balanceRecordsRef.current?.fetchBalanceRecord();
  };

  return (
    <Row gutter={[16, 16]}>
      <Col xs={24}>
        <MainAccBalance
          ref={mainAccBalanceRef}
          onAddMoneySuccess={handleAddMoneySuccess}
        />
      </Col>
      <Col xs={24}>
        <BalanceRecords ref={balanceRecordsRef} />
      </Col>
    </Row>
  );
}
